import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  appName: 'KinoGram',
  unauthenticatedBaseUrl: '/',
  authenticatedBaseUrl: '/',
  localStoragePrefix: 'kg-',
  graphqlApi: 'https://dev-kinogram.develtio.dev/api/graphql',
  websocketUri: 'wss://dev-kinogram.develtio.dev/api/graphql',
  staticAssetsUrl: 'https://dev-kinogram.develtio.dev/api/static',
  enableTechnicalBreakCheck: true,
  googleClientId: '177913734833-fm8lceli1ktsnis9apumkb8d70qngsva.apps.googleusercontent.com',
};
